import React, { FC } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { CouponsPage } from './pages';

const Coupons: FC = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}`} component={CouponsPage} />
    </Switch>
  );
};

export default Coupons;
